var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_vm._v("Please wait ...")]):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"width":"500px","height":"500px"},attrs:{"id":"rp_container"}})])}
var staticRenderFns = []

export { render, staticRenderFns }